import I18n from 'I18n';
import { SUPPORTED_LANGS } from '../Constants';
export function getLanguage() {
  if (I18n && SUPPORTED_LANGS.indexOf(I18n.lang) > -1 && I18n.langEnabled) {
    return I18n.lang;
  }
  return 'en';
}